import * as XLSX from 'xlsx';

export const exportToExcel = (data, columns, filename) => {
  const rows = data.map((item, index) => {
    const row = { '#': index + 1 };
    columns.forEach((col) => {
      row[col.header] = item[col.key] ?? '';
    });
    return row;
  });

  const wb = XLSX.utils.book_new();
  const ws = XLSX.utils.json_to_sheet(rows);
  XLSX.utils.book_append_sheet(wb, ws, 'Data');
  XLSX.writeFile(wb, filename);
};
